module.exports = __webpack_public_path__ + "static/media/sour-patch.18cccae3.png";